import { Tile as TileLayer, Vector as VectorLayer, Image as ImageLayer, Group } from "ol/layer";
import { OSM, XYZ, Vector as VectorSource, ImageWMS, TileWMS } from "ol/source";
import Overlay from "ol/Overlay";
import GeoJSON from "ol/format/GeoJSON";
import axios from 'axios';
import moment from 'moment';
import store from '@/store/store';
import baseLayers from '@/helpers/base_layers';

async function getLayerParams(layer) {
  let params = {
    property_params: layer.property_params,
    zIndex: layer.property_params.zindex,
    opacity: layer.property_params.opacity,
    visible: layer.property_params.visible,
    name: layer.name,
    id: layer.id,
    url_params: layer.url_params,
    url_caption: layer.url_caption ? layer.url_caption : '',
    server: layer.server ? layer.server : '',
    event_params: layer.event_params ? layer.event_params : undefined,
    tooltip_params: layer.tooltip_params ?? layer.tooltip_params,
    disabled: layer.disabled ? layer.disabled : false,
    caption_html: layer.caption_html ? layer.caption_html : undefined,
    hide_on_menu: layer.hide_on_menu ? layer.hide_on_menu : false,
    icon_params: layer.icon_params ? layer.icon_params : undefined,
  };

  if (layer.animation_type && layer.params) {
    const animationProperties = layer.params[layer.animation_type];
    await store.dispatch('loadTimeFeatures', {
      url: animationProperties.URL_GEOJSON
    });
    const features = store.getters.timeFeatures.features;
    if (features.length > 0) {
      params.timeFeatures = features.map(feature => ({
        title: moment(feature.properties[animationProperties.TIME_FEATURE_PROPERTY], 'YYYY-MM-DDTHH:mm').format(animationProperties.TITLE_DATETIME_FORMAT),
        value: feature.properties[animationProperties.TIME_FEATURE_PROPERTY],
        layerId: layer.id
      }));
    }
  }
  return params;
}

const getSublayers = async (layers) => {
  let groupLayers = [];
  let overlayerFeatures = [];
  for (const key in layers) {
    const group = layers[key];
    let sublayers = [];
    for (let key2 in group.layers) {
      const layer = group.layers[key2];

      if (layer.property_params) {
        const layerParams = await getLayerParams(layer);

        if (layer.animation_type && layerParams.timeFeatures && typeof layer.url_params != 'undefined') {
          layer.url_params.time = layerParams.timeFeatures[0].value;
        }

        if (layer.layer_class === 'ol.layer.Tile' && layer.layer_type === 'ol.source.TileWMS') {
          let holder = new TileLayer({
            source: new TileWMS({
              url: layer.url,
              crossOrigin: 'Anonymous',
              params: layer.url_params,
            }),
            ...layerParams
          });
          sublayers.push(holder);
        } else if (layer.layer_class === 'ol.layer.Image' && layer.layer_type === 'ol.source.ImageWMS') {
          let holder = new ImageLayer({
            source: new ImageWMS({
              url: layer.url,
              crossOrigin: 'Anonymous',
              params: layer.url_params,
            }),
            ...layerParams
          });
          sublayers.push(holder);
        } else if (layer.layer_class === 'ol.layer.Vector' && layer.layer_type === 'ol.source.Vector') {
          const params = layer.params;
          const { data } = await axios.get(layer.url);
          let { features } = data;
          overlayerFeatures = features;
          layer.params.unscaledNums = features.map(feature => feature.properties[params.chart_options.attribute_size]);
          let holder = new VectorLayer({
            source: new VectorSource({
              url: layer.url,
              format: new GeoJSON(),
              crossOrigin: 'Anonymous',
              params: layer.params,
              serverType: 'geoserver'
            }),
            ...layerParams,
          })
          sublayers.push(holder)
        }
      }
    }
    groupLayers.push({
      ...group,
      layers: sublayers,
      overlayerFeatures
    });
  }
  return groupLayers
}

const getGroupLayers = async (olMap, sublayers) => {

  sublayers.forEach((sublayer) => {
    olMap.addLayer(new Group({
      ...sublayer
    }));
  });
}

const getBaseLayerBasics = (layer, visible) => {
  const { title } = baseLayers[layer];
  let baseLayer = new TileLayer({
    title,
    type: 'base',
    source: new OSM(),
    visible
  });
  return baseLayer;
}

const getBaseLayerEsri = (layer, visible) => {
  const { title, url } = baseLayers[layer];
  const baseLayer = new TileLayer({
    title,
    type: 'base',
    source: new XYZ({
      url
    }),
    visible,
    crossOrigin: "Anonymous"
  });
  return baseLayer
}

const getDataFeatures = async (event, source, view) => {
  const viewResolution = view.getResolution();
  let layers = source.getParams().LAYERS;
  const feature_url = source.getFeatureInfoUrl(
    event.coordinate, viewResolution, view.getProjection(),
    { 'INFO_FORMAT': 'application/json', 'QUERY_LAYERS': layers, 'FEATURE_COUNT': (10) }
  );
  const dataFeatures = await axios.get(feature_url);
  const feature_properties = dataFeatures.data.features ? dataFeatures.data.features : undefined;
  return feature_properties;
}

const addOverlayMap = (olMap, element, positioning) => {
  const overlay = new Overlay({
    element,
    positioning,
    autoPan: true,
    autoPanAnimation: {
      duration: 250,
    },
  });
  olMap.addOverlay(overlay);
  return overlay;
}

export {
  getSublayers,
  getGroupLayers,
  getBaseLayerBasics,
  getBaseLayerEsri,
  getDataFeatures,
  addOverlayMap
}
